export default __webpack_public_path__ + "static/media/AboutIcon.230b3cbb.png";